import cn from "classnames";
import { dateToView } from "helpers/date";
import { documentStatuses, documentStatusesEnum } from "helpers/enums";
import { enumLabel } from "helpers/system";
import React, { useState } from "react";
import { getDocumentFile } from "sources/billing";

export default function BillingDocuments(props) {
    const [loading, setLoading] = useState(false);
    const downloadItem = (item) => {
        setLoading(true);
        const { id } = item;
        getDocumentFile(id)
            .catch(() => undefined)
            .finally(() => setLoading(false));
    };
    return (
        <table className={cn("table table-sm", { loading })}>
            <thead>
                <tr>
                    <th>Тип документа</th>
                    <th>Номер</th>
                    <th>Сумма</th>
                    <th>Название</th>
                    <th>Дата создания</th>
                    <th>Период</th>
                    <th>Статус</th>
                    <th>Отправлен</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {props.items.map((item) => (
                    <tr key={item.id}>
                        <td>{item.templateName}</td>
                        <td>{item.number}</td>
                        <td>{item.sum}</td>
                        <td>{item.agreementName}</td>
                        <td>{dateToView(item.createDate)}</td>
                        <td>{dateToView(item.period)}</td>
                        <td>
                            {item.templateName.startsWith("Акт") ? (
                                ""
                            ) : (
                                <span
                                    className={cn("badge", {
                                        "badge-success": item.status === documentStatusesEnum.Paid,
                                        "badge-danger": item.status === documentStatusesEnum.Unpaid,
                                        "badge-secondary": item.status === documentStatusesEnum.Expired,
                                    })}
                                >
                                    {enumLabel(documentStatuses, item.status)}
                                </span>
                            )}
                        </td>
                        <td>{item.isSent ? "Да" : "Нет"}</td>
                        <td>
                            <div className="btn btn-sm text-primary" onClick={() => downloadItem(item)}>
                                <i className="icon-uEA52-load-point" />
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
